import { render, staticRenderFns } from "./MsgTemplateList.vue?vue&type=template&id=174613fc&scoped=true&"
import script from "./MsgTemplateList.vue?vue&type=script&lang=js&"
export * from "./MsgTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MsgTemplateList.vue?vue&type=style&index=0&id=174613fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174613fc",
  null
  
)

export default component.exports